import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

// Create axios instance with auth
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const milestonesApi = {
  /**
   * CREATE MILESTONE POST
   * Endpoint: POST /api/posts/milestones
   * Body: { milestone, content }
   */
  createMilestone: async (milestoneData) => {
    return apiClient.post("/posts/milestones", milestoneData);
  },

  /**
   * GET MILESTONE TYPES
   * Endpoint: GET /api/posts/milestones/types
   */
  getMilestoneTypes: async () => {
    return apiClient.get("/posts/milestones/types");
  },

  /**
   * GET USER MILESTONES
   * Endpoint: GET /api/posts/milestones/user/:userId
   */
  getUserMilestones: async (userId) => {
    return apiClient.get(`/posts/milestones/user/${userId}`);
  },
};

export default milestonesApi;
